"use strict";
var _a, _b, _c, _d, _e;
Object.defineProperty(exports, "__esModule", { value: true });
exports.IU = void 0;
/* eslint-disable sonarjs/no-duplicate-string */
var instances_1 = require("../../../types/instances");
var brands_1 = require("../../brands");
var environments_1 = require("../../environments");
var localesAndRegions_1 = require("../../localesAndRegions");
var navigation_1 = require("./navigation");
exports.IU = {
    brand: brands_1.BrandName.IU,
    region: localesAndRegions_1.RegulatoryRegion.DACH,
    deployment: instances_1.MondrianDeploymentType.AMPLIFY,
    company: 'IU International University',
    microFrontends: [
        'auth',
        'core',
        'dashboard',
        'dev-overlay',
        'directories',
        'exam',
        'gradeview',
        'learn',
        'navbar',
        'news',
        'payment',
        'profile',
        'static-pages',
        'student-calendar',
        'student-document',
        'student-service-desk',
        'study-plan',
        'student-mentorship',
        'user-experience-and-feedback',
    ],
    redirects: [{ from: '/', to: '/home' }],
    apiBaseUrl: (_a = {},
        _a[environments_1.Environment.DEV] = 'https://api-dev.iu.org',
        _a[environments_1.Environment.NONPROD] = 'https://api-non-prod.iu.org',
        _a[environments_1.Environment.PROD] = 'https://api.iu.org',
        _a),
    moodleBaseUrl: (_b = {},
        _b[environments_1.Environment.DEV] = 'https://dev.mycampus-classic.iu.org',
        _b[environments_1.Environment.NONPROD] = 'https://stage.mycampus-classic.iu.org',
        _b[environments_1.Environment.PROD] = 'https://mycampus.iubh.de',
        _b),
    auth0: (_c = {},
        _c[environments_1.Environment.DEV] = {
            domain: 'auth-dev.iu.org',
            clientId: 'EXHCDIXQDNH1ZqSUmuCLpowGVrjf1lYk',
            audience: 'https://api-dev.iu.org',
        },
        _c[environments_1.Environment.NONPROD] = {
            domain: 'auth-stage.iu.org',
            clientId: 'gvNIcl5RO4T5piJjjeENs63inB5k9sBZ',
            audience: 'https://api-non-prod.iu.org',
        },
        _c[environments_1.Environment.PROD] = {
            domain: 'auth.iu.org',
            clientId: 'ZcE0wR5CndGiTNxAoLg9OJEL6b3OjTv6',
            audience: 'https://api.iu.org',
        },
        _c),
    meta: {
        title: 'myCampus - IU International University',
        description: 'myCampus - Embark on your learning journey with the ultimate platform focused on you and your studies!',
        keywords: [
            'IU',
            'my',
            'study',
            'learn',
            'manage',
            'International University',
            'IUBH',
        ],
    },
    aws: (_d = {},
        _d[environments_1.Environment.PROD] = {
            domain: 'idss-prod.iu-aws.de',
        },
        _d[environments_1.Environment.NONPROD] = {
            domain: 'idss-nonprod.iu-aws.de',
        },
        _d[environments_1.Environment.DEV] = {
            domain: 'idss-dev.iu-aws.de',
        },
        _d),
    hostname: (_e = {},
        _e[environments_1.Environment.PROD] = {
            domain: 'mycampus.iu.org',
            allowImportMapOverrides: false,
        },
        _e[environments_1.Environment.NONPROD] = {
            domain: 'mycampus.iu.org',
            subDomain: 'stage',
            allowImportMapOverrides: true,
        },
        _e[environments_1.Environment.DEV] = {
            domain: 'mycampus.iu.org',
            subDomain: 'dev',
            allowImportMapOverrides: true,
        },
        _e),
    navigation: function (navigationContext) {
        return (0, navigation_1.getIUNavigationItems)(navigationContext);
    },
};
